import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import validator from "validator";
import { forgotPassword } from "../services/user-service";
import "./../css/resetpassword.css";

const TrusteeApproval = ({ username }) => {
  const [passwordvalidation, setPasswordvalidation] = useState(false);
  const [confirmpasswordvalidation, setConfirmpasswordvalidation] =
    useState(false);

  const navigate = useNavigate();

  const [tempData, setTempData] = useState({
    password: "",
    cpassword: "",
  });

  const validate = (value) => {
    if (
      validator.isStrongPassword(value, {
        minLength: 10,
        minNumbers: 1,
        minLowercase: 1,
        minUppercase: 1,
        minSymbols: 1,
      })
    ) {
      setPasswordvalidation(true);
    } else {
      setPasswordvalidation(false);
    }
  };

  const confirmvalidate = (value) => {
    if (
      validator.isStrongPassword(value, {
        minLength: 10,
        minNumbers: 1,
        minLowercase: 1,
        minUppercase: 1,
        minSymbols: 1,
      })
    ) {
      setConfirmpasswordvalidation(true);
    } else {
      setConfirmpasswordvalidation(false);
    }
  };

  const handleChanges = (event, property) => {
    setTempData({ ...tempData, [property]: event.target.value });
    if (property === "password") {
      validate(event.target.value);
    }
    if (property === "cpassword") {
      confirmvalidate(event.target.value);
    }
  };

  const resetData = () => {
    setTempData({
      password: "",
      cpassword: "",
    });
  };

  const submitForm = (event) => {
    event.preventDefault();

    if (
      tempData.password !== tempData.cpassword ||
      tempData.password === "" ||
      tempData.cpassword === ""
    ) {
      toast.error("Password and Confirm Password must be same.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!passwordvalidation) {
      toast.error(
        "Password must be strong (min 10 chars, include upper, lower, number, symbol).",
        { position: toast.POSITION.BOTTOM_CENTER }
      );
      return;
    }

    const data = {
      username: username,
      password: tempData.password,
    };

    forgotPassword(data)
      .then(() => {
        toast.success("Password reset successfully.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        navigate("/");
      })
      .catch(() => {
        toast.error("Something went wrong. Try again!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });
  };

  return (
    <div>
      <Container className="restepassword_container">
        <div className="restepassword_maincard">
          <Card>
            <CardHeader className="cardheading">
              <h3 className="heading">Reset your password</h3>
            </CardHeader>
            <CardBody className="resetpassword_cardbody">
              <Form onSubmit={submitForm}>
                {/* New Password field */}
                <FormGroup className="textfield">
                  <Label className="resetpassword_heading" for="password">
                    New Password
                  </Label>
                  <Input
                    className="resetpassword_inputfiled"
                    type="password"
                    placeholder="Enter your new password"
                    id="password"
                    onChange={(e) => handleChanges(e, "password")}
                    value={tempData.password}
                    valid={passwordvalidation}
                    invalid={!passwordvalidation && tempData.password !== ""}
                    autoComplete="new-password"
                  />
                </FormGroup>

                {/* Confirm Password field */}
                <FormGroup className="textfield">
                  <Label className="resetpassword_heading" for="cpassword">
                    Confirm Password
                  </Label>
                  <Input
                    className="resetpassword_inputfiled"
                    type="password"
                    placeholder="Re-enter your new password"
                    id="cpassword"
                    onChange={(e) => handleChanges(e, "cpassword")}
                    value={tempData.cpassword}
                    valid={confirmpasswordvalidation}
                    invalid={
                      !confirmpasswordvalidation && tempData.cpassword !== ""
                    }
                  />
                </FormGroup>

                <Container className="loginbuttons">
                  <Button
                    className="cler-button"
                    onClick={resetData}
                    color="warning"
                    outline
                    type="reset"
                  >
                    Clear
                  </Button>

                  <Button
                    className="register-button"
                    color="success"
                    outline
                    type="submit"
                  >
                    Submit
                  </Button>
                </Container>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default TrusteeApproval;
